import { useQuery } from '@tanstack/react-query';
import { fetchMinerRewards, type RewardsResponse } from '../lib/minerApi.js';

export function useMinerRewards(address: string | null, page = 1) {
  return useQuery<RewardsResponse | null>({
    queryKey: ['miner-rewards', address, page],
    queryFn: async () => {
      if (!address) return null;
      return fetchMinerRewards(address, page);
    },
    enabled: !!address,
    staleTime: 300_000,
    retry: 1,
  });
}
